<template>
    <div class="ei-article-detail">
        <h3 class="title">{{title}}</h3>
        <div class="time">时间：{{time}}</div>
        <div class="ql-editor" v-html="content" style="min-height: 300px"></div>
    </div>
</template>

<script>

	export default {
		name: "EiArticleDetail",
		props: {
			title: {
				type: String,
				required: true
			},
			time: {
				type: String,
				required: true
			},
			content: {
				type: String,
				required: true
			}

		},
		created() {

		}
	}
</script>

<style scoped lang="scss">
    .ei-article-detail {
        width: 1258px;
        height: 100%;
        margin: 0 auto;
        position: relative;

        h3 {
            text-align: center;
            font-size: 26px;
        }

        .time {
            margin-top: 20px;
            text-align: center;
            margin-bottom: 30px;
            color: #8c939d;
        }
    }
</style>
